/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from 'react'
import { Box, Space } from '@gousto-internal/citrus-react'
import { Column, Grid } from 'goustouicomponents/dist'
import { OptimizelyFeature } from '@optimizely/react-sdk'
import { HelpHero } from '../../components/HelpHero'
import { store } from '../../store'
import { LoginPrompt } from '../../components/LoginPrompt'
import { Topics } from '../../components/Topics'
import { TopIssues } from '../../components/TopIssues'
import { LastOrder } from '../../components/LastOrder'
import { CustomerNotification } from '../../components/CustomerNotification'
import { getHasCheckedAuthentication, getIsAuthenticated } from '../../selectors/auth'
import css from './Help.module.css'
import { useBlockBodyScroll } from '../../hooks/useBlockBodyScroll'
import { isMobile } from '../../utils/isMobile'

const Help = () => {
  const { state } = useContext(store)
  const isAuthenticated = getHasCheckedAuthentication(state) && getIsAuthenticated(state)
  const [isMobileSearchResultVisible, setIsMobileSearchResultVisible] = useState(false)
  const showBackdrop = isMobileSearchResultVisible && isMobile()

  useBlockBodyScroll(showBackdrop)

  return (
    <div className={css.wrapper}>
      <HelpHero
        onSearchMobileToggle={setIsMobileSearchResultVisible}
        isMobileSearchResultVisible={isMobileSearchResultVisible}
      />
      <Box
        css={{ position: 'relative' }}
        paddingH={[0, 6]}
      >
        {showBackdrop && (
          <Box
            data-testing="search-backdrop"
            onClick={() => setIsMobileSearchResultVisible(false)}
            className={css.backdrop}
          />
        )}
        <Space size={[6, 12]} />
        <OptimizelyFeature feature="haricots_help_centre_web_notification_toggle">
          {(isEnabled) => (
            isEnabled
            && (
              <>
                <CustomerNotification />
                <Space size={6} />
              </>
            )
          )}
        </OptimizelyFeature>
        <Grid>
          <Column
            smallScreen={12}
            largeScreen={6}
            hasPaddingSmallScreen={false}
            hasPaddingMediumScreen={false}
            hasPaddingLargeScreen={false}
            extraClass={css.column}
          >
            {isAuthenticated ? <LastOrder /> : <LoginPrompt />}
          </Column>
          <Column
            smallScreen={12}
            largeScreen={6}
            hasPaddingSmallScreen={false}
            hasPaddingMediumScreen={false}
            hasPaddingLargeScreen={false}
          >
            <TopIssues />
          </Column>
        </Grid>
        <Space size={8} />
        <Topics />
      </Box>
    </div>
  )
}

export { Help }
